module.exports = __webpack_public_path__ + "feffc8124927aed165c2ac6d68928eb4.jpg";